import type { Routes } from '@angular/router';
import HomeComponent from './frontend/home/home.component';
import { authGuardFn } from '@auth0/auth0-angular';
import {
  canActivateChildRoleGuard,
  canActivateRoleGuard,
} from './frontend/user/guard/can-role.guard';

export const appRoutes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () => import('./frontend/user/user.routes'),
  },
  {
    path: 'auditors',
    loadChildren: () => import('./frontend/auditor/auditor.routes'),
    data: { bodyClass: 'szeged-bg' },
  },
  {
    path: 'map',
    loadComponent: () => import('./frontend/map/map.component'),
  },
  {
    path: 'game',
    loadComponent: () => import('./frontend/game/game.component'),
    data: { bodyClass: 'game-bg' },
  },
  {
    path: 'gala-dinner',
    canActivate: [canActivateRoleGuard('VipGold')],
    loadComponent: () => import('./frontend/gala-dinner/gala-dinner.component'),
  },
  {
    path: 'apply-workshop',
    canActivate: [canActivateRoleGuard('VipSilver')],
    loadComponent: () => import('./frontend/apply-workshop/apply-workshop.component'),
  },
  {
    path: 'apply-seminar',
    canActivate: [canActivateRoleGuard('VipSilver')],
    loadComponent: () => import('./frontend/apply-seminar/apply-seminar.component'),
  },
  {
    path: 'admin',
    canActivateChild: [authGuardFn, canActivateChildRoleGuard('Admin')],
    children: [
      {
        path: 'auditors',
        canActivate: [canActivateRoleGuard('SuperAdmin')],
        loadChildren: () => import('./admin/auditor/auditor.routes'),
      },
      {
        path: 'users',
        canActivate: [canActivateRoleGuard('Admin')],
        loadChildren: () => import('./admin/user/user.routes'),
      },
      {
        path: 'qrcode-checker',
        loadComponent: () => import('./admin/read-qr-code/read-qr-code.component'),
      },
      {
        path: 'admins',
        canActivate: [canActivateRoleGuard('SuperAdmin')],
        loadChildren: () => import('./admin/admin/admin.routes'),
      },
      {
        path: 'programs',
        canActivate: [canActivateRoleGuard('SuperAdmin')],
        loadChildren: () => import('./admin/program/program.routes'),
      },
      {
        path: 'partners',
        canActivate: [canActivateRoleGuard('SuperAdmin')],
        loadChildren: () => import('./admin/partner/partner.routes'),
      },
      {
        path: 'map',
        canActivate: [canActivateRoleGuard('SuperAdmin')],
        loadComponent: () => import('./admin/map/map.component'),
      },
      {
        path: 'gala-dinner',
        canActivate: [canActivateRoleGuard('SuperAdmin')],
        loadComponent: () => import('./admin/gala-dinner/gala-dinner.component'),
      },
      {
        path: 'exhibition-stands',
        canActivate: [canActivateRoleGuard('SuperAdmin')],
        loadChildren: () => import('./admin/exhibition-stand/exhibition-stand.routes'),
      },
      {
        path: 'push-notifications',
        canActivate: [canActivateRoleGuard('SuperAdmin')],
        loadChildren: () => import('./admin/push-notification/push-notification.routes'),
      },
      {
        path: 'workshop-applications',
        canActivate: [canActivateRoleGuard('SuperAdmin')],
        loadComponent: () =>
          import('./admin/workshop-application/list/workshop-application-list.component'),
      },
      {
        path: 'seminar-applications',
        canActivate: [canActivateRoleGuard('SuperAdmin')],
        loadComponent: () =>
          import('./admin/seminar-application/list/seminar-application-list.component'),
      },
      {
        path: 'players',
        canActivate: [canActivateRoleGuard('SuperAdmin')],
        loadComponent: () => import('./admin/player/list/player-list.component'),
      },
    ],
  },
];
